import { render, staticRenderFns } from "./warranty-icon.vue?vue&type=template&id=c1accb62"
import script from "./warranty-icon.vue?vue&type=script&lang=js"
export * from "./warranty-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports